import axios from 'axios';

const BASE = (process.env.REACT_APP_EZTS_API_BASE_URL || '').replace(/\/+$/, '');

/** Auth header comes from axios interceptor (ensureAccessToken / refresh). */

export function getCurrentYearDateRange() {
  const year = new Date().getFullYear();
  return { from: `${year}-01-01`, to: `${year}-12-31` };
}

function filterExpensesInRange(list, from, to) {
  if (!from && !to) return list;
  return list.filter((e) => {
    const date = String(e?.expenseDate ?? e?.date ?? '').slice(0, 10);
    if (!date) return false;
    return (!from || date >= from) && (!to || date <= to);
  });
}

function unwrapPayload(data) {
  if (data == null) return data;
  if (typeof data === 'object' && 'data' in data && data.data != null) {
    return unwrapPayload(data.data);
  }
  return data;
}
 
export async function getExpenses({ filters }) {
  const url = `${BASE}/expense/all`;
 
  const params = { orgId: 1 };
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        params[key] = value;
      }
    });
  }
 
  const res = await axios.get(url, {
    params,
  });
 
  return res.data;
}
 
export async function getExpenseTypes({ orgId = 1 } = {}) {
  const url = `${BASE}/expense/expense_type/all`;
 
  const res = await axios.get(url, {
    params: { orgId },
  });
 
  return Array.isArray(res.data) ? res.data : [];
}
 
export function normalizeExpensePendingCount(data) {
  const payload = unwrapPayload(data);

  if (typeof payload === 'number') return payload;

  if (payload && typeof payload === 'object') {
    const pick = (...keys) => {
      for (const key of keys) {
        const val = payload[key];
        if (typeof val === 'number' && !Number.isNaN(val)) return val;
      }
      return null;
    };

    const direct =
      pick('pending', 'pendingCount', 'pendings', 'count', 2, '2') ??
      null;
    if (direct != null) return direct;

    if (Array.isArray(payload.counts)) {
      const pendingRow = payload.counts.find(
        (row) =>
          row?.status === 2 ||
          row?.status === 'pending' ||
          row?.statusId === 2
      );
      if (pendingRow && typeof pendingRow.count === 'number') {
        return pendingRow.count;
      }
    }
  }

  return null;
}

export function countPendingExpenses(list) {
  const items = Array.isArray(list) ? list : [];
  return items.filter((e) => {
    const raw = e?.status ?? e?.statusId;
    return raw === 2 || raw === 'pending' || String(raw).toLowerCase() === 'pending';
  }).length;
}

export async function getExpenseCount({ orgId = 1, userId, from, to } = {}) {
  if (!userId) throw new Error('Missing userId');

  const range = getCurrentYearDateRange();
  const url = `${BASE}/expense/count`;

  const res = await axios.get(url, {
    params: {
      orgId,
      userId,
      from: from ?? range.from,
      to: to ?? range.to,
    },
  });

  const parsed = normalizeExpensePendingCount(res.data);
  if (typeof parsed === 'number') return parsed;
  return null;
}

export async function getPendingExpenseCountFromList({ orgId = 1, userId, from, to } = {}) {
  const range = getCurrentYearDateRange();
  const url = `${BASE}/expense/all`;

  const res = await axios.get(url, {
    params: {
      orgId,
      userId,
      from: from ?? range.from,
      to: to ?? range.to,
    },
  });

  const payload = unwrapPayload(res.data);
  const list = Array.isArray(payload) ? payload : [];
  const rangeFrom = from ?? range.from;
  const rangeTo = to ?? range.to;
  return countPendingExpenses(filterExpensesInRange(list, rangeFrom, rangeTo));
}
 
export async function createExpense(payload) {
  const url = `${BASE}/expense`;
 
  const res = await axios.post(url, payload);
 
  return res.data;
}
 
export async function updateExpense(payload) {
  const url = `${BASE}/expense`;

  const res = await axios.post(url, payload);

  return res.data;
}
